import AddNewButton from 'Components/Generic/Buttons/AddNewButton';
import { SITE_PAGES } from 'Config';
import { user_roles } from 'Data/Enum';
import SiteDrawerData from 'Data/SiteDrawerData';
import ServiceContractLanding from 'Pages/ServiceContracts/ServiceContractLanding';
import ServiceContractListView from 'Pages/ServiceContracts/ServiceContractListView';
import ServiceContractView from 'Pages/ServiceContracts/ServiceContractView';
import { isUserAuthorized } from 'Util';

const ManageServiceContractsView = () => {
  const breadcrumb = [SITE_PAGES.ALL_SERVICE_CONTRACTS];

  let drawerContent = <ServiceContractView compact editable hideToggle isNew />;
  const onClick = () => {
    SiteDrawerData.open({
      content: drawerContent,
      title: 'New Service Contract',
      size: { defaultWidth: 800, minWidth: 580 },
    });
  };

  let addNewButton = isUserAuthorized({
    roles: [user_roles.SC_ADMIN],
  }) && (
    <AddNewButton
      buttonText='Add Service Contract'
      clickHandler={onClick}
      tableButton
    />
  );

  return (
    <ServiceContractLanding breadcrumbs={breadcrumb}>
      <ServiceContractListView addNewButton={addNewButton} />
    </ServiceContractLanding>
  );
};

export default ManageServiceContractsView;
